import { Avatar, Box, Button, Dialog, Grid, Stack, Typography } from "@mui/material"

export const ToolsModal = ({toolOwned, handleClickTools, openModal, setOpenModal}) => {
    return (
        <Dialog
            open={openModal}
            onClose={()=>setOpenModal(false)}
            fullWidth={true} 
            maxWidth="xl"
            sx={{bgcolor:'#30303033', height:'100%', width:'100%', display:'flex', justifyContent:'center', alignItems:'center'}}
            PaperProps={{
                sx:{
                    backgroundColor:'transparent !important',
                    boxShadow:'0px 0px 0px 0px !important',
                    overflow:'hidden'
                }
            }}
        >
            <Box height={{xs:'500px', lg:'600px'}} width={{xs:'100%', lg:'1068px'}} p="40px" border="1px solid #D6D9DB" bgcolor="#FFFFFF" borderRadius="12px">
                <Box height="100%" width="100%" display="flex" flexDirection="column" gap="16px" >
                    <Box minHeight="37px" display="flex" justifyContent="center" gap="12px">
                        <Typography fontWeight={700} fontSize={28} lineHeight="132%" letterSpacing="-2%" color="#292C2F">Your tool accessed</Typography>
                    </Box>
                    <Grid container direction="row" alignContent="flex-start" gap="12px" height="100%" className="overflowY" pr={1}>
                        {toolOwned?.map((v,k) => (
                            <Grid item key={k} sm={5.8} md={3.8} lg={3.9} height="140px" width="100%" borderRadius="12px" border="1px solid #D6D9DB" bgcolor="#FFFFFF"
                                sx={{boxShadow:'0px 2px 4px 0px #00000005'}}
                            >
                                <Stack height="100%" justifyContent="center" gap="12px" p="24px">
                                    <Stack direction="row" alignItems="center" gap="12px">
                                        <Avatar src={JSON.parse(v.logo)} variant="square" sx={{height:'32px', width:'32px', borderRadius:'4px'}}/>
                                        <Stack minWidth={0} gap="4px">
                                            <Typography fontSize={16} fontWeight={600} lineHeight="120%" letterSpacing="-0.75%" color="#292C2F" noWrap>
                                                {v.name}
                                            </Typography>
                                            <Typography fontSize={12} fontWeight={400} lineHeight="147%" letterSpacing="-0.75%" color="#292C2F" noWrap>
                                                {v.description}
                                            </Typography>
                                        </Stack>
                                    </Stack>
                                    <Button onClick={()=>handleClickTools(v.tid)} sx={{height:'36px', width:'100%', borderRadius:'4px', bgcolor:'#F7F8F8','&:hover':{bgcolor:'#F7F8F8'} }}>
                                        <Typography fontSize={12} fontWeight={400} lineHeight="142%" letterSpacing="0%" color="#292C2F">Open</Typography>
                                    </Button>
                                </Stack>
                            </Grid>
                        ))}
                    </Grid>
                    <Box minHeight="18px">
                        <Typography fontWeight={400} fontSize={12} lineHeight="147%" letterSpacing="-0.75%" color="#5B6167">Total Count {toolOwned.length}</Typography>
                    </Box>
                </Box>
            </Box>
        </Dialog>
    )
}